import React from "react";
import { useTranslation } from "react-i18next";
import './OurServices.css'
import VectorOne from "../../assets/images/our-services/vector-1.png";
import VectorTwo from "../../assets/images/our-services/vector-2.png";
import VectorThree from "../../assets/images/our-services/vector-3.png";
import VectorFour from "../../assets/images/our-services/vector-4.png";
import VectorFive from "../../assets/images/our-services/vector-5.png";
import VectorSix from "../../assets/images/our-services/vector-6.png";
import { Link } from "react-router-dom";
import useLangLink from "../../utils/useLangLink";

/* Links and artwork stay in code; only the copy comes from the locale. */
/* `wrap: false` on the first card mirrors the original markup, which omitted
   the .hs-column-content wrapper there. */
const CARDS = [
    { to: "/ready-made", img: VectorOne, wrap: false },
    { to: "/ready-made-companies-corporate-bank-accounts", img: VectorTwo, wrap: true },
    { to: "/financial-license", img: VectorThree, wrap: true },
    { to: "/financial-license", img: VectorFour, wrap: true },
    { to: "/offshore-company-formation", img: VectorFive, wrap: true },
    { to: "/offshore-bank-account-opening", img: VectorSix, wrap: true },
];

function OurServices () {
    const { t } = useTranslation();
    const lp = useLangLink();
    const ts = (k, d) => t(`sections.ourServices.${k}`, d);
    const obj = (k) => ts(k, { returnObjects: true });

    const cards = obj('cards') || [];

    return (
        <div className='wrapper'>
            <div className='our-service-container container '>
                <div className='home-services-info '>
                    <h1 className='our-service-title section-subtitle '>{ts('title')}</h1>
                    <p
                        className='our-service-description'
                        dangerouslySetInnerHTML={{ __html: ts('description') }}
                    />
                </div>

                <div className='our-service-content'>
                    {CARDS.map((card, i) => {
                        const body = (
                            <>
                                <h1 className='our-service-content-title'>
                                    {cards[i] && cards[i].title}
                                </h1>
                                <p
                                    className='our-service-card-description'
                                    dangerouslySetInnerHTML={{ __html: (cards[i] && cards[i].description) || '' }}
                                />
                            </>
                        );

                        return (
                            <Link key={i} to={lp(card.to)} className='our-service-card our-service-card-link'>
                                <div className='our-service-vector-box'>
                                    <img src={card.img} alt={ts('imgAlt')} className='our-service-vector'/>
                                </div>
                                {card.wrap ? <div className='hs-column-content'>{body}</div> : body}
                            </Link>
                        );
                    })}
                </div>

                <div className='our-service-list-container'>
                    <ul className='our-service-list'>
                        <div className='our-service-list-card'>
                            <h3 className='our-service-list_title'>
                                {ts('otherPractices.title')}
                            </h3>
                            {(obj('otherPractices.column1') || []).map((item, i) => (
                                <li key={i} className="our-service-list-item">{item}</li>
                            ))}
                        </div>
                        <div className='our-service-list-card'>
                            {(obj('otherPractices.column2') || []).map((item, i) => (
                                <li key={i} className="our-service-list-item">{item}</li>
                            ))}
                        </div>
                    </ul>
                </div>

            </div>
        </div>
    )
}

export default OurServices;
